<template>
  <div class="network-check">
    <div v-if="isElectron" class="pointer" @click="onClose"></div>
    <div v-else class="close-btn" @click="onClose">
      <img src="../../../assets/images/close.png" alt="" />
    </div>
    <div v-if="!isChecking" class="check-title">
      <div class="title-area">
        <div class="title">{{ isCheckEnd ? "网络检测完成" : "网络检测" }}</div>
        <p class="progress progress-tips">
          {{
            isCheckEnd ? "已完成本次网络检测。" : "检测准备就绪，请点击开始检测"
          }}
        </p>
      </div>
      <button @click="startCheck" :disabled="isChecking" class="start-btn">
        {{ isChecked ? "重新检测" : "开始检测" }}
      </button>
    </div>
    <div v-else class="check-title">
      <div class="title-area">
        <div class="title">网络检测</div>
        <p class="progress">已经检测完成 {{ progress }}% ...</p>
      </div>
      <button @click="stopCheck" :disabled="!isChecking" class="stop-btn">
        退出检测
      </button>
    </div>
    <ul class="check-list">
      <li v-for="(item, index) in checkList" :key="index">
        <span>{{ item.label }}</span>
        <span
          class="result"
          :class="{
            normal: item.status === 2,
            abnormal: item.status === 3,
          }"
          >{{ item.result || "待检测" }}</span
        >
      </li>
    </ul>
  </div>
</template>

<script>
import { request } from "@saas/service-api/src/request.js";
export default {
  data() {
    return {
      isElectron: window.isElectron,
      isChecking: false,
      isChecked: false,
      isCheckEnd: false,
      progress: 0,
      checkList: [
        // {
        //   key: "network",
        //   status: 0, // 0: 未检查，1:检查中，2: 已通过，3: 已失败
        //   label: "网络权限",
        //   result: "待检测",
        //   fn: this.testNetworkPermissions,
        // },
        {
          key: "connection",
          status: 0, // 0: 未检查，1:检查中，2: 已通过，3: 已失败
          label: "网络连接情况",
          result: "待检测",
          fn: this.testConnection,
        },
        {
          key: "mtu",
          status: 0, // 0: 未检查，1:检查中，2: 已通过，3: 已失败
          label: "最大传输单元检测",
          result: "待检测",
          fn: this.testMTUValue,
        },
        {
          key: "dns",
          status: 0, // 0: 未检查，1:检查中，2: 已通过，3: 已失败
          label: "域名解析检测",
          result: "待检测",
          fn: this.testDNSResolution,
        },
        {
          key: "server",
          status: 0, // 0: 未检查，1:检查中，2: 已通过，3: 已失败
          label: "服务器连接情况",
          result: "待检测",
          fn: this.testServerConnection,
        },
      ],
      networkStatus: {
        network: null,
        connection: null,
        mtu: null,
        dns: null,
        server: null,
      },
      timeout: null,
    };
  },
  methods: {
    async startCheck() {
      clearTimeout(this.timeout);
      this.isCheckEnd = false;
      this.isChecked = true;
      this.checkList.forEach((item) => {
        item.status = 1;
        item.result = "检测中";
      });
      this.isChecking = true;
      this.progress = 0;
      // 模拟分步检测，这里只是示例，实际可按需修改检测逻辑
      const steps = 4;
      for (let i = 0; i < this.checkList.length; i++) {
        if (this.isChecking === false) {
          this.checkList[i].status = 0;
          this.checkList[i].result = "待检测";
        } else {
          await this.checkList[i].fn(this.checkList[i]);
          this.progress = ((i + 1) / steps) * 100;
          await new Promise((resolve) => {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(resolve, 1000);
          });
        }
      }
      this.isCheckEnd = true;
      this.isChecking = false;
    },

    stopCheck() {
      this.isChecking = false;
      clearTimeout(this.timeout);
      // this.checkList.forEach((item) => {
      //   item.status = 0;
      // });
    },
    // 1. 测试网络权限
    async testNetworkPermissions(item) {
      let hasNetworkPermission = true;
      try {
        // 检查网络访问权限
        console.log("检查网络访问权限");
        console.log(navigator.onLine);

        if (navigator.onLine === false) {
          hasNetworkPermission = false;
        }

        // 检查定位权限
        if (navigator.permissions) {
          const locationStatus = await navigator.permissions.query({
            name: "geolocation",
          });
          console.log("locationStatus>>>>", locationStatus);
          if (locationStatus.state === "denied") {
            hasNetworkPermission = false;
          }
        }

        // 检查后台网络权限
        if ("BackgroundFetchManager" in self) {
          const bgStatus = await navigator.permissions.query({
            name: "background-fetch",
          });
          console.log("bgStatus>>>>", bgStatus);
          if (bgStatus.state === "denied") {
            hasNetworkPermission = false;
          }
        }
        if (!hasNetworkPermission) {
          item.status = 3;
          item.result = "检查失败";
        } else {
          item.status = 2;
          item.result = "正常";
        }
      } catch (error) {
        item.status = 3;
        item.result = "检查失败";
        return false;
      }
    },

    // 2. 测试网络连接
    async testConnection(item) {
      // 检查浏览器网络API支持
      if (navigator.onLine) {
        item.status = 2;
        item.result = "正常";
      } else {
        item.status = 3;
        item.result = "网络连接异常";
      }
    },
    // 3. 测试MTU
    async testMTUValue(item) {
      // 通过尝试不同大小的数据包并测量成功率来估计MTU
      // MTU测试URL
      const testUrls = [
        {
          size: 1400,
          url: `https://www.baidu.com/s?wd=${"a".repeat(
            1400
          )}&random=${Date.now()}`,
        },
        {
          size: 1450,
          url: `https://www.baidu.com/s?wd=${"a".repeat(
            1450
          )}&random=${Date.now()}`,
        },
        {
          size: 1492,
          url: `https://www.baidu.com/s?wd=${"a".repeat(
            1492
          )}&random=${Date.now()}`,
        },
        {
          size: 1500,
          url: `https://www.baidu.com/s?wd=${"a".repeat(
            1500
          )}&random=${Date.now()}`,
        },
        {
          size: 1514,
          url: `https://www.baidu.com/s?wd=${"a".repeat(
            1514
          )}&random=${Date.now()}`,
        },
      ];

      let maxSuccessfulSize = 0;

      for (let i = 0; i < testUrls.length; i++) {
        const testUrl = testUrls[i];
        //   updateStepProgress(
        //     3,
        //     (i + 1) * 20,
        //     `测试MTU大小: ${testUrl.size} bytes...`
        //   );

        try {
          // 超时设置为2秒
          const controller = new AbortController();
          const timeoutId = setTimeout(() => controller.abort(), 2000);

          const response = await fetch(testUrl.url, {
            mode: "no-cors",
            signal: controller.signal,
          });

          clearTimeout(timeoutId);

          if (response.ok || response.status === 0) {
            maxSuccessfulSize = testUrl.size;
          }
        } catch (error) {
          // 如果是第一个失败的，使用前一个成功的大小
          if (maxSuccessfulSize > 0) break;
        }
      }

      // 更新MTU结果
      let recommendedMTU = maxSuccessfulSize;
      if (recommendedMTU === 0) recommendedMTU = 1492; // 默认值
      // 根据MTU值提供建议
      let recommendation = "";
      let isSuccess = true;
      if (recommendedMTU < 1400) {
        // recommendation =
        //   "您的MTU值较低，可能会影响网络性能。建议检查您的网络设备设置。";
        isSuccess = false;
      } else if (recommendedMTU >= 1500) {
        // recommendation = "您的MTU值设置理想，可获得最佳网络性能。";
        isSuccess = true;
      } else {
        // recommendation =
        //   "您的MTU值正常，但可能不是最优值。对于大多数网络，1500 bytes是理想的MTU值。";
        isSuccess = true;
      }

      //   document.getElementById("mtuRecommendation").textContent = recommendation;

      //   markStepComplete(3, "MTU检测完成", isSuccess);
      if (isSuccess) {
        item.status = 2;
        item.result = "正常";
      } else {
        item.status = 3;
        item.result = "检测失败";
      }
    },

    // 4. 测试DNS解析
    async testDNSResolution(item) {
      console.log("testDNSResolution");
      // 注意：浏览器安全限制使得直接进行DNS查询变得困难
      // 我们可以通过测量不同域名的解析时间来间接测试
      // 同时使用Web API获取一些网络信息
      try {
        const domain = process.env.VUE_APP_SAAS_WEB_URL;
        // 测量解析时间
        const start = performance.now();
        // 使用用户指定的域名进行测试
        const response = await fetch(domain, {
          mode: "no-cors",
        });
        console.log(response);
        const end = performance.now();
        const dnsTime = Math.round(end - start);
        console.log(dnsTime);
        // 尝试获取IP地址 (使用WebRTC API的技巧)
        let ipAddress = "无法获取";
        try {
          ipAddress = await this.getIPAddress();
        } catch (e) {
          console.error("获取IP地址失败:", e);
        }

        // // 尝试检测CDN (基于域名)
        // let cdnProvider = "未知";
        // const cdnIndicators = {
        //   cloudflare: /cloudflare/i,
        //   akamai: /akamai/i,
        //   fastly: /fastly/i,
        //   tencent: /tencent/i,
        //   aliyun: /aliyun/i,
        //   qiniu: /qiniu/i,
        // };

        // for (const [provider, regex] of Object.entries(cdnIndicators)) {
        //   if (regex.test(domain)) {
        //     cdnProvider = provider.charAt(0).toUpperCase() + provider.slice(1);
        //     break;
        //   }
        // }

        // 更新结果
        console.log("ipAddress>>>", ipAddress);

        if (response.ok || (response.status === 0 && ipAddress)) {
          item.status = 2;
          item.result = "正常";
        } else {
          item.status = 3;
          item.result = "解析失败";
        }
      } catch (error) {
        console.log("error>>>", error);

        item.status = 3;
        item.result = "解析失败";
      }
    },

    // // 5. 测试服务器连接
    async testServerConnection(item) {
      const serverUrl = process.env.VUE_APP_ADMIN_API + "/health";
      try {
        const start = performance.now();
        const { code } = await request(serverUrl, "get", {});
        if (code) {
          item.status = 2;
          item.result = "正常";
        } else {
          item.status = 3;
          item.result = "服务器连接失败";
        }
      } catch (error) {
        console.log("服务测试》〉》〉", error);
        item.status = 3;
        item.result = "服务器连接失败";
      }
    },
    // 获取IP地址的辅助函数 (使用WebRTC)
    getIPAddress() {
      return new Promise((resolve, reject) => {
        // 创建RTCPeerConnection实例
        const pc = new RTCPeerConnection({ iceServers: [] });
        const ips = new Set();

        // 添加一个数据通道
        pc.createDataChannel("");

        // 创建一个offer
        pc.createOffer()
          .then((offer) => pc.setLocalDescription(offer))
          .catch(reject);

        // 监听ICE候选
        pc.onicecandidate = (e) => {
          if (!e.candidate) return;

          // 从candidate中提取IP地址
          const parts = e.candidate.candidate.split(" ");
          const ip = parts[4];

          if (ip && !ip.startsWith("127.")) {
            ips.add(ip);
          }
        };

        // 等待一段时间后解析结果
        setTimeout(() => {
          pc.close();
          if (ips.size > 0) {
            resolve(Array.from(ips).join(", "));
          } else {
            resolve("无法获取");
          }
        }, 1000);
      });
    },
    onClose() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped lang="scss">
.network-check {
  width: 512px;
  background: #18181b;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.06),
    0px 1px 3px 0px rgba(0, 0, 0, 0.1);
  border-radius: 12px 12px 12px 12px;
  border: 1px solid rgba(229, 231, 235, 0.04);
  padding: 13px 24px 24px 24px;
  .pointer {
    width: 16px;
    height: 16px;
    background: #f53f3f;
    border-radius: 50%;
    cursor: pointer;
    &:hover {
      background-image: url("../../../assets/images/icon/close_hover.png");
      background-size: 100% 100%;
    }
  }
  .close-btn {
    width: 24px;
    height: 24px;
    float: right;
    cursor: pointer;
  }
  .check-title {
    display: flex;
    width: 100%;
    margin-top: 8px;
    justify-content: space-between;
    align-items: center;
    .title-area {
      .title {
        font-weight: 600;
        font-size: 20px;
        color: #ecedee;
        line-height: 28px;
      }
      .progress {
        margin-top: 4px;
        font-weight: 500;
        font-size: 14px;
        color: #a1a1aa;
        line-height: 20px;
      }
      .progress-tips {
        font-weight: 400;
      }
    }
    button {
      width: 88px;
      height: 40px;
      background: #0e42d2;
      border-radius: 12px 12px 12px 12px;
      font-size: 14px;
      color: #e8f3ff;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      font-weight: 500;
      &.stop-btn {
        background: #cb2634;
        color: #ffece8;
      }
    }
  }
  .check-list {
    margin-top: 24px;
    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 36px;
      line-height: 36px;
      font-weight: 400;
      font-size: 14px;
      color: #a1a1aa;
      margin-bottom: 8px;
      &:last-child {
        margin-bottom: 0;
      }
      .result {
        color: #ecedee;
      }
      span {
        &.normal {
          color: green;
        }
        &.abnormal {
          color: red;
        }
      }
    }
  }
}

ul {
  list-style-type: none;
  padding: 0;
}
</style>
